module.exports = __webpack_public_path__ + "assets/images/passengers_phase3.4846e32ecd6584b3e1a6343b2502dfce.svg";